angular.module('dealerware.web.data').factory('DealerwareFleetModel', function ($http, Model, DataUtils) {

    var dataUtils = DataUtils.getInstance();

    var model = new Model({
        baseEndpoint: '/locations/:location_id/fleet',
        customActions:  {
            getUploadStatus: {
                method                          : 'GET',
                endpoint                        : '/locations/:location_id/fleet/upload_status',
                ignoreAssociations              : true,
                responseFormatter               : {
                    format: function (response) {
                        return mapAgreementToggleResponse(response);
                    }
                },
            },
        },

        requestTransforms   : {
            create: function(data) {
                if (data.id) { delete(data.id); }
            }
        }
    });

    function mapAgreementToggleResponse (response) {

        return angular.extend(response.data, {
            created_at: dataUtils.pastDateWordify(response.data.created_at, false, true)
        });
    }

    // This doesn't go through the normal Model code massaging because it's a pdf
    // upload that uses its own plugin. The endpoint is located here mainly to
    // keep it with all the Loaner Agreement endpoints.
    //
    jQuery.extend(model, {
        uploadFleet: {
            endpoint: '/locations/:location_id/fleet'
        }
    } );

    return model;
});
